import React from 'react'
import { MwSpinnerButton, NoDataFound } from '../ui'
import LineChart from '../charts/LineChart'
import { Link } from 'react-router-dom'

const MonthlyLineChart = ({
    tenantUsername,
    loading,
    monthlyList,
    label
}) => {
    return (
        <div className="h-full flex flex-col">
            {loading ? (
                <div className="flex-1 flex items-center justify-center">
                    <MwSpinnerButton isFullCenter={true} withLabel={false} />
                </div>
            ) : monthlyList.length > 0 ? (
                <div className="flex-1">
                    <LineChart
                        label={label}
                        datasetData={monthlyList}
                        loading={loading}
                    />
                </div>
            ) : (
                <div className="flex-1 flex items-center justify-center border-2 border-dashed border-[#f5b800]/30 bg-[#fffaf0] rounded-3xl">
                    <NoDataFound msg={`لا يوجد تذاكر دعم حالياً`}>
                        <div className='flex gap-3 justify-center items-center mt-4'>
                            <Link to={`/${tenantUsername}/tickets/add`}>
                                <button className="bg-[#f5b800] text-[#08203f] px-6 py-2.5 rounded-xl font-black hover:bg-[#d99d00] transition-all shadow-[0_12px_24px_rgba(245,184,0,.24)] active:scale-[0.98]">
                                    إنشاء تذكرة دعم جديدة
                                </button>
                            </Link>
                        </div>
                    </NoDataFound>
                </div>
            )}
        </div>
    )
}

export default MonthlyLineChart
